import { createContext } from 'react'

const buyerContext = createContext()

export default buyerContext
